<script lang="ts">
  import { onDestroy, type Snippet } from "svelte";
  import {interactions} from "../lib/interactions.svelte"
  import FirstWins from "../lib/FirstWins";

  let {
    dismiss_with,
    slot,
    children
  } : {
    dismiss_with: string[];
    slot?: string;
    children?: Snippet;
  } = $props()
  let hidden = $derived(!interactions.initialized || interactions.getEvents(...dismiss_with).length)
  let firstWins = new FirstWins(slot)

  // When changing between pages with turbolinks, the slots variable in firstWins persits. We have to release it on destroy
  // or the second page load cannot claim the slot.
  onDestroy(() => { firstWins.release() })
</script>
{#if firstWins.wins(!hidden)}
  {@render children()}
{/if}
